<template>
  <div class="le-tp-header">
    <div class="le-tp-header-con">
      <div class="le-tp-tool-col">
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-bao-cun" title="保存" @click="handleClickEvent(btnEventCode.saveData)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-shang-bu" title="撤销" @click="handleClickEvent(btnEventCode.undoOperate)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-xia-bu" title="恢复" @click="handleClickEvent(btnEventCode.redoOperate)" />
        </div>
      </div>

      <div class="le-tp-tool-col">
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" :class="{'is-active' : tpOptions.selectedActive}" icon="lt tp-icon-xuan-ze" title="选择模式" @click="handleClickEvent(btnEventCode.selectShape)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" :class="{'is-active' : tpOptions.joinLineActive}" icon="lt tp-icon-lian-xian" title="连线模式" @click="handleClickEvent(btnEventCode.joinLineShape)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-quan-xuan" title="选择所有图形" @click="handleClickEvent(btnEventCode.selectAllGraph)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-fu-zhi" title="复制图形" @click="handleClickEvent(btnEventCode.copyShape)" />
        </div>
        <div class="le-tp-btn-item">
          <el-dropdown class="le-tp-btn-dropdown" placement="bottom" @visible-change="handleVisibleChangeEvent">
            <el-button class="le-tp-btn" icon="lt tp-icon-tou-ming" title="透明度" />

            <el-dropdown-menu slot="dropdown" class="le-tp-btn-dropdown-menu">
              <div class="le-btn-transparency">
                <div class="le-transparency-header">
                  <span class="title">图形不透明度</span>
                </div>
                <div class="le-transparency-body">
                  <el-slider v-model="shapeOpacity" :show-input="true" :show-input-controls="false" @change="handleOpacityChangeEvent" />
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!--        <div class="le-tp-btn-item">-->
        <!--          <el-dropdown class="le-tp-btn-dropdown" placement="bottom-start" @command="handleCommandEvent">-->
        <!--            <el-button class="le-tp-btn" icon="lt tp-icon-zuo-dui-qi" title="对齐">-->
        <!--              <i class="el-icon-arrow-down el-icon&#45;&#45;right" />-->
        <!--            </el-button>-->
        <!--            <el-dropdown-menu slot="dropdown" class="le-tp-btn-dropdown-menu">-->
        <!--              <el-dropdown-item icon="lt tp-icon-zuo-dui-qi" :command="btnEventCode.alignLeft">左对齐</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-you-dui-qi" :command="btnEventCode.alignRight">右对齐</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-shang-dui-qi" :command="btnEventCode.alignTop">顶部对齐</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-xia-dui-qi" :command="btnEventCode.alignBottom">底部对齐</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-shui-ping-ju-zhong" :command="btnEventCode.horizontalCenter">水平居中</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-chui-zhi-ju-zhong" :command="btnEventCode.verticalCenter">垂直居中</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-shui-ping-deng-fen" :command="btnEventCode.horizontalSpacing">水平等间距</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-chui-zhi-deng-fen" :command="btnEventCode.verticalSpacing">垂直等间距</el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <!--        </div>-->
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-ding-ceng" title="置顶" @click="handleClickEvent(btnEventCode.layerTop)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-di-ceng" title="置底" @click="handleClickEvent(btnEventCode.layerBottom)" />
        </div>
        <!--        <div class="le-tp-btn-item">-->
        <!--          <el-dropdown class="le-tp-btn-dropdown" placement="bottom-start" @command="handleCommandEvent">-->
        <!--            <el-button class="le-tp-btn" icon="lt tp-icon-xia-yi-ceng" title="层级">-->
        <!--              <i class="el-icon-arrow-down el-icon&#45;&#45;right" />-->
        <!--            </el-button>-->
        <!--            <el-dropdown-menu slot="dropdown" class="le-tp-btn-dropdown-menu">-->
        <!--              <el-dropdown-item icon="lt tp-icon-ding-ceng" :command="btnEventCode.layerTop">置顶</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-di-ceng" :command="btnEventCode.layerBottom">置底</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-shang-yi-ceng" :command="btnEventCode.layerUp">上移一层</el-dropdown-item>-->
        <!--              <el-dropdown-item icon="lt tp-icon-xia-yi-ceng" :command="btnEventCode.layerDown">下移一层</el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <!--        </div>-->
        <!--        <div class="le-tp-btn-item">-->
        <!--          <el-button v-if="!groupStatus" class="le-tp-btn" icon="lt tp-icon-zu-he" title="组合" @click="handleClickEvent(btnEventCode.groupShape)" />-->
        <!--          <el-button v-if="groupStatus" class="le-tp-btn" icon="lt tp-icon-qu-xiao-zu-he" title="取消组合" @click="handleClickEvent(btnEventCode.ungroupShape)" />-->
        <!--        </div>-->
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-suo-ding" title="锁定图形" @click="handleClickEvent(btnEventCode.lockShape)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-jie-suo" title="取消图形锁定" @click="handleClickEvent(btnEventCode.unlockShape)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-shi-ying-ping-mu" title="适应屏幕" @click="handleClickEvent(btnEventCode.canvasFitView)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-shi-ji-da-xiao" title="实际大小" @click="handleClickEvent(btnEventCode.canvasActualSize)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-shan-chu" title="删除" @click="handleClickEvent(btnEventCode.deleteShape)" />
        </div>
      </div>

      <div class="le-tp-tool-col">
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-quan-ping" title="全屏" @click="handleClickEvent(btnEventCode.fullScreen)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" icon="lt tp-icon-yu-lan" title="预览" @click="handleClickEvent(btnEventCode.previewStage)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" :class="{'is-active' : tpOptions.showAside}" icon="lt tp-icon-zuo-xian" title="图形组件" @click="handleClickEvent(btnEventCode.windowLeft)" />
        </div>
        <div class="le-tp-btn-item">
          <el-button class="le-tp-btn" :class="{'is-active' : tpOptions.showAttribute}" icon="lt tp-icon-you-xian" title="图形属性" @click="handleClickEvent(btnEventCode.windowRight)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {childMixins, commonMixins} from '../../scripts/mixins';
import {btnEventCodeConst, elementNameConst, eventNameConst, stateConst} from '../../scripts/conf';

export default {
  name: 'LeTpHeader',
  mixins: [childMixins, commonMixins],
  data() {
    return {
      btnEventCode: btnEventCodeConst,
      shapeOpacity: 100
    };
  },
  methods: {
    handleClickEvent(command) {
      this.$emit(eventNameConst.generalEvent.click, command);
    },
    handleCommandEvent(command) {
      this.handleClickEvent(command);
    },
    handleVisibleChangeEvent(status) {
      if (!status) {
        this.shapeOpacity = 100;
      }
    },
    handleOpacityChangeEvent(val) {
      const opacity = Number((val / 100).toFixed(1));
      // 查询所有选中的元素
      const nodes = this.getCanvasStage().findAllByState(elementNameConst.node, stateConst.selected);
      const combos = this.getCanvasStage().findAllByState(elementNameConst.combo, stateConst.selected);
      const shapeArray = [...nodes, ...combos];
      shapeArray?.forEach(item => {
        const model = item.get('model');
        if (model) {
          model.style.opacity = opacity;
          item.update(model);
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
